import { AsyncActionConstants } from '../types'

export const createAsyncConstants = (type: string): AsyncActionConstants => ({
  REQUEST: `${type}.REQUEST`,
  SUCCESS: `${type}.SUCCESS`,
  FAILURE: `${type}.FAILURE`,
  ACTION: type,
})
